import { useMutation, useQuery, useQueryClient } from "react-query";
import { useEmployeesState } from "atoms/employeesAtom";

import { GetEmployeesParams } from "../types";

import {
  addEmployee,
  deleteEmployee,
  editEmployee,
  getEmployees,
  reassignWorker,
} from "./index";

const useOnSuccess = () => {
  const queryClient = useQueryClient();
  const { setEmployeesState } = useEmployeesState();

  return () => {
    queryClient.invalidateQueries({ queryKey: ["get-employees"] });

    setEmployeesState((prev) => ({
      ...prev,
      activeItem: null,
    }));
  };
};

export const useGetEmployees = (params: GetEmployeesParams) => {
  return useQuery(["get-employees", { ...params }], () => getEmployees(params));
};

export const useDeleteEmployee = () => {
  const onSuccess = useOnSuccess();

  return useMutation(["delete-employee"], deleteEmployee, {
    onSuccess,
  });
};

export const useReassignWorker = () => {
  const onSuccess = useOnSuccess();

  return useMutation(["reassign-worker"], reassignWorker, {
    onSuccess,
  });
};

export const useAddEmployee = () => {
  const onSuccess = useOnSuccess();

  return useMutation(["add-employee"], addEmployee, {
    onSuccess,
  });
};

export const useEditEmployee = () => {
  const onSuccess = useOnSuccess();

  return useMutation(["edit-employee"], editEmployee, {
    onSuccess,
  });
};
